import React from 'react'
import { Form, Modal, message, DatePicker, Spin, } from 'antd'
import { Route, Link, BrowserRouter as Router } from 'react-router-dom'
import Layouts from '../components/Layouts'
import CreditNotecomponent from './CreditNote.js'
import moment from 'moment'
import apiRequest from '../hooks/ApiRequest.js'

function roundvalue(value) {
  if (value > 0) {
    return parseFloat(value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
  }
}
class CancelPolicy extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      policyId: localStorage.getItem('PolicyID'),
      policynumber: '',
      PolicyEndDate: '',
      PolicyStartDate: '',
      PolicyAnnualPremium: '',
      totalannualpremium: '',
      CreditNoteVisible: false,
      RefundPolicyID: 0,
      clientname: '',
      RefundableAmount: '0.0',
      buttonCancel: false,
      cancellationdate: new Date(),
      clientUuid: '',
      refund: '',
      cancelDate: '',
      policyStatus: '',
      loading: false,
      currentDate: new Date(),
      clientid: localStorage.getItem('loggedInUserID'),
    }
    this.calculateRefundableAmount = this.calculateRefundableAmount.bind(this)
    this.findDayDifference = this.findDayDifference.bind(this)
    this.GenerateNote = this.GenerateNote.bind(this)
    this.setVisibleFalse = this.setVisibleFalse.bind(this)
    this.buttonSet = this.buttonSet.bind(this)
  }

  async componentDidMount() {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Policy/GetPolicybyid/${this.state.policyId}`,
        'GET'
      );
  
      if (response.success) {
        const { policydetail, customerdetail } = response.data;
        
        this.setState({
          policynumber: policydetail.policynumber,
          PolicyStartDate: policydetail.policystartdate,
          PolicyEndDate: policydetail.policyexpirytdate,
          PolicyAnnualPremium: policydetail.totalannualpremium,
          clientname: policydetail.customername,
          clientUuid: customerdetail.nationalid,
          policyStatus: policydetail.policystatus,
          cancellationdate: policydetail.policystartdate
        });
      } else {
        console.error("API Error:", response.error);
      }
    } catch (error) {
      console.error("Request failed:", error);
    }
  }
  

  setVisibleFalse() {
    this.setState({ CreditNoteVisible: false })
    window.location.href = '/policies'
  }

  handleCancel(val) {
    localStorage.setItem('PolicyID', val)
    // this.setState({RefundPolicyID:val});
    // this.setState({CreditNoteVisible:true});
    window.location.href = '/cancelPolicy'
  }

  findDayDifference(date1, date2) {
    // always round down
    return Math.floor(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24))
  }
  componentWillUnmount() {
    localStorage.removeItem('PolicyID')
  }
  GenerateNote() {
    this.setState({ CreditNoteVisible: true })
  }
async buttonSet() {
  this.setState({ loading: true });

  if (!this.state.cancellationdate) {
    message.warning('Select cancellation date to cancel the policy');
    this.setState({ loading: false });
    return;
  }

  try {
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/Policy/CancelPolicy`;
    
    const postBody = {
      policynumber: this.state.policynumber,
      cancellationdate: this.state.cancellationdate,
      refundamount: this.state.RefundableAmount,
      createdby: parseInt(this.state.clientid),
      premium: this.state.PolicyAnnualPremium,
      policyid: this.state.policyId,
    };

    console.log("Request Payload:", postBody);

    const response = await apiRequest(apiUrl, 'POST', postBody);

    if (response.success && response.data.responseMessage === 'Policy cancelled Succesfully.') {
      message.success('Policy cancelled Successfully');
      this.setState({ buttonCancel: true });
    } else {
      message.error(response.error || 'Failed to cancel policy');
    }
  } catch (error) {
    console.error("Request failed:", error);
    message.error('Something went wrong, please try again');
  } finally {
    this.setState({ loading: false });
  }
}


  calculateRefundableAmount(date, datestring) {
    if (
      new Date(datestring) >= new Date(this.state.PolicyStartDate) &&
      datestring !== ' '
    ) {
      var Noofdays = this.findDayDifference(
        new Date(this.state.PolicyEndDate),
        new Date(datestring),
      )
      Noofdays = Noofdays + 1
      this.setState({
        RefundableAmount: roundvalue(
          this.state.PolicyAnnualPremium * (Noofdays / 365),
        ),
      })
      this.setState({ cancellationdate: datestring })
    } else {
      message.warning(
        'Cancellation date cannot be smaller than Policy start date',
      )
    }
  }

  render() {
    return (
      <Layouts classname="dashboard">
        <Spin
          className="loader-icon-fixed"
          spinning={this.state.loading}
          size="large"></Spin>
        <div className="white-box-bg">
          <div className="dash-heading">
            <h3>CANCEL POLICY</h3>
          </div>

          <div className="form-group-box">
            <div className="form-group">
              <label>Customer Name: </label>
              {this.state.clientname}
            </div>
            <div className="form-group">
              <label>National Id: </label>
              {this.state.clientUuid}
            </div>
            <div className="form-group">
              <label>Policy number:</label>
              {this.state.policynumber}
            </div>
            <div className="form-group">
              <label>Policy start date:</label>
              {this.state.PolicyStartDate}
            </div>
            <div className="form-group">
              <label>Policy end date:</label>
              {this.state.PolicyEndDate}
            </div>
            <div className="form-group">
              <label>Premium:</label>
              {this.state.PolicyAnnualPremium}
            </div>
            <div className="form-group d-flex">
              <label>Cancellation Date:</label>
              <Form.Item>
                <DatePicker
                  placeholder="Cancellation date"
                  value={moment(
                    this.state.cancellationdate,
                    this.state.dateFormat,
                  )}
                  onChange={this.calculateRefundableAmount}
                />
              </Form.Item>
            </div>

            <div className="form-group">
              <label>Refundable amount:</label>
              {this.state.RefundableAmount}
            </div>

            <div className="cancel-policy-button">
              <label className="blank-space"></label>
              {!this.state.buttonCancel && (
                <button
                  type="primary"
                  onClick={this.buttonSet}
                  style={{ float: 'center' }}>
                  Cancel Policy
                </button>
              )}
              {this.state.buttonCancel && (
                <button type="primary" onClick={this.GenerateNote}>
                  Generate Credit Note
                </button>
              )}
            </div>
          </div>

          <Modal
            centered
            visible={this.state.CreditNoteVisible}
            footer={null}
            onCancel={this.setVisibleFalse}
            width={1000}>
            <CreditNotecomponent parentToChild={this.state.RefundPolicyID} />
          </Modal>
        </div>
      </Layouts>
    )
  }
}
export default CancelPolicy
